// src/context/PermissionContext.js
import React, { createContext, useContext, useEffect, useState } from "react";
import { getPermissionJson } from "../services/authService";

// Create the context
const PermissionContext = createContext();

// Export a custom hook for easy access
export const usePermissions = () => useContext(PermissionContext);

// Create a provider component
export const PermissionProvider = ({ children }) => {
  const [permissionJson, setPermissionJson] = useState({});

  useEffect(() => {
    const fetchPermissionJson = async () => {
      try {
        const apiRes = await getPermissionJson();
        setPermissionJson(apiRes?.data)
      }
      catch (err) {
        console.error('Failed to fetch permission : ', err)
      }
    }
    fetchPermissionJson()
  }, [])

  return (
    <PermissionContext.Provider value={permissionJson}>
      {children}
    </PermissionContext.Provider>
  );
};
